import React, { useMemo, useState } from "react";
import { NavLink } from "react-router-dom";
import styles from "./Book.module.css";

export default function BookSidebar({ manifest, currentSlug, baseRoute = "/course" }) {
  const [q, setQ] = useState("");

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    if (!s) return manifest?.sections || [];
    const groups = [];
    (manifest?.sections || []).forEach((sec) => {
      const items = (sec.items || []).filter(
        (it) =>
          (it.title || "").toLowerCase().includes(s) ||
          (it.slug || "").toLowerCase().includes(s)
      );
      if (items.length) groups.push({ ...sec, items });
    });
    return groups;
  }, [q, manifest]);

  return (
    <aside className={styles.sidebar}>
      <div className={styles.sidebarHeader}>
        <div className={styles.bookTitle}>{manifest?.title || "Libro"}</div>
        <input
          className={styles.search}
          placeholder="Buscar tema..."
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <div className={styles.sidebarBody}>
        {filtered.map((sec) => (
          <div key={sec.title} className={styles.section}>
            <div className={styles.sectionTitle}>{sec.title}</div>
            <div className={styles.sectionItems}>
              {(sec.items || []).map((it) => (
                <NavLink
                  key={it.slug}
                  to={`${baseRoute}/${manifest.id}/${it.slug}`}
                  className={({ isActive }) =>
                    [styles.item, isActive || currentSlug === it.slug ? styles.itemActive : ""].join(" ")
                  }
                >
                  {it.title}
                </NavLink>
              ))}
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
}
